import { axiosClient } from '@App/api/api-client'
import Pathes from '@App/dicts/pathes'
import { AxiosResponse } from 'axios'
import { AkaTitleType, Countries, Language, WriterRoles } from '@Entities/lib'

export const getLanguages = (): Promise<AxiosResponse<Language[]>> => axiosClient.get<Language[]>(Pathes.Lib.langs)

export const getAkaTitleTypes = (): Promise<AxiosResponse<AkaTitleType[]>> =>
    axiosClient.get<AkaTitleType[]>(Pathes.Lib.akaTitleTypes)

export const getWriterRoles = (): Promise<AxiosResponse<WriterRoles[]>> =>
    axiosClient.get<WriterRoles[]>(Pathes.Lib.writerRoles)

export const getCountries = (): Promise<AxiosResponse<Countries[]>> =>
    axiosClient.get<Countries[]>(Pathes.Lib.countries)
